export default "__VITE_ASSET__3f7bc3fd__"